import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { fetchAllProjects } from '../../store/slices/projectsSlice'
import { useDispatch, useSelector } from 'react-redux'
import AttachFileIcon from "@mui/icons-material/AttachFile";
import { fetchLeads } from '../../store/slices/leadsSlice';
import { fetchGroups } from '../../store/slices/groupSlice';
import FileUploadMyTraining from './FileUploadMyTraining';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useSnackbar } from 'notistack';
import { deleteTraining, getMyTrainings, sendTrainingReminder, updateTraining } from '../../store/slices/MyTraining/myTrainings';
import { reconcileTrainingLinkedOtherExpenses } from '../../store/slices/descriptionTaskSlice';
import AdminLoader from '../../components/common/loader/AdminLoader';
import { fetchEmployees } from '../../store/slices/employeeSlice';
import AddIcon from '@mui/icons-material/Add';
import { fetchGroupOne } from '../../store/slices/groupOneSlice';
import axiosInstance from '../../config/axiosConfig';
import config from '../../config/api';
import { getTrainingFiles, uploadTrainingFile } from '../../store/slices/MyTraining/myTrainingFileUploadSlice';
import DeleteIcon from "@mui/icons-material/Delete";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import { MdSearch } from "react-icons/md";
import { useCurrencySymbol } from '../../utils/currencyUtils';
import DateConversion from '../../utils/DateConversion';
import CommaConvert from '../../utils/CommaConvert';
import { getFeatureAccessLevel, hasViewOrFullAccess } from '../../utils/featureAccessUtils';
import useSubscriptionLevel from '../../utils/SubscriptionLevel';

const MyTraining = () => {
  const USAComma = CommaConvert();
  const dispatch = useDispatch()
  const subscriptionPackage = useSubscriptionLevel();
  const isCrmPackage = String(subscriptionPackage || "").trim().toUpperCase() === "CRM";
  const isErpPackage = String(subscriptionPackage || "").trim().toUpperCase() === "ERP";
  const currency = useCurrencySymbol();
  const { formatDateByCountry, getDatePlaceholder, getDateFormat } = DateConversion();
  const formatDateByCountryRef = useRef(formatDateByCountry);
  formatDateByCountryRef.current = formatDateByCountry;
  const { enqueueSnackbar } = useSnackbar();
  const { leads } = useSelector((state) => state.leads);
  const { group } = useSelector((state) => state.group);
  const { employees } = useSelector((state) => state.employees);
  const { mytrainings } = useSelector((state) => state.myTrainings);
  const { projects } = useSelector((state) => state.projects);
  const { data } = useSelector((state) => state.groupOne);
  const [isModal, setIsModal] = useState(false);
  const [trainingID, setTrainingID] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [trainingindex, setTrainingIndex] = useState();
  const tableScrollRef = useRef(null);

  const mytrainingOMMyManagement = useSelector(
    (state) => state.operationState.mytrainingOMMyManagement
  );

  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    dispatch(fetchGroupOne());
    dispatch(fetchLeads());
    dispatch(fetchGroups());
    dispatch(fetchEmployees());
    dispatch(getMyTrainings());
    dispatch(fetchAllProjects());
  }, [dispatch]);

  const [loggedEmp, setLoggedEmp] = useState(null);
  useEffect(() => {
    const Email = localStorage.getItem("email")
    const Emp = employees.find((emp) => emp?.EmpEmail === Email)
    setLoggedEmp(Emp)
  }, [employees])

  const managerProjectsForErpPmDropdown = useMemo(() => {
    if (!(isErpPackage && loggedEmp?.EmpAuthLevel === "L4" && loggedEmp?.customRoles?.includes("project manager"))) {
      return [];
    }
    const userEmail = String(loggedEmp?.EmpEmail || "").trim().toLowerCase();
    const directManagerProjects = (projects || []).filter((project) =>
      (project?.AssignedManagerEmail || []).some(
        (email) => String(email || "").trim().toLowerCase() === userEmail
      )
    );

    const uniqueByProjectName = new Map();
    directManagerProjects.forEach((project) => {
      const projectNameKey = String(project?.ProjectName || "")
        .trim()
        .toLowerCase();
      if (projectNameKey) {
        if (!uniqueByProjectName.has(projectNameKey)) {
          uniqueByProjectName.set(projectNameKey, project);
        }
        return;
      }
      const fallbackKey = String(project?.quotationId || project?._id || "").trim();
      if (fallbackKey && !uniqueByProjectName.has(fallbackKey)) {
        uniqueByProjectName.set(fallbackKey, project);
      }
    });

    return Array.from(uniqueByProjectName.values());
  }, [isErpPackage, loggedEmp, projects]);

  const hasNoFeatureConfig = !loggedEmp?.featureAccess || loggedEmp.featureAccess.length === 0;
  const trainingAccessLevel = getFeatureAccessLevel(loggedEmp, "MY TRAININGS");
  const canShowMyTraining = hasViewOrFullAccess(loggedEmp, "MY TRAININGS");
  const isViewOnly = !hasNoFeatureConfig && trainingAccessLevel &&
    String(trainingAccessLevel).trim().toUpperCase() === "VIEW ONLY";

  const [filtereedEmployees, setFiltereedEmployees] = useState([]);
  const [myTrainingData, setMyTrainingData] = useState([
    {
      groupId: "",
      projectname: "",
      projectid: "",
      leadid: "",
      quotationId: "",
      trainingname: "",
      assignedto: "",
      duedate: "",
      enddate: "",
      linktotraining: "",
      trainingcost: "",
      status: "",
    },
  ]);

  const [filteredLeads, setFilteredLeads] = useState([]);
  const [filteredEmpGroups, setFilteredEmpGroups] = useState([]);
  const [selectedFile, setSelectedFile] = useState([]);
  const assignedProjectsForErpL4 = useMemo(() => {
    if (!(isErpPackage && loggedEmp?.EmpAuthLevel === "L4")) return [];

    const userEmail = String(loggedEmp?.EmpEmail || "").trim().toLowerCase();
    const userName = `${loggedEmp?.EmpFirstName || ""} ${loggedEmp?.EmpLastName || ""}`
      .trim()
      .toLowerCase();

    return (projects || []).filter((project) => {
      const isAssignedManager = (project?.AssignedManagerEmail || []).some(
        (email) => String(email || "").trim().toLowerCase() === userEmail
      );
      const isAssignedPerson = (project?.Assignedperson || []).some((person) => {
        const personEmail = String(person?.email || person?.EmpEmail || "").trim().toLowerCase();
        const personName = String(person?.name || "").trim().toLowerCase();
        return personEmail === userEmail || (userName && personName === userName);
      });
      return isAssignedManager || isAssignedPerson;
    });
  }, [isErpPackage, loggedEmp, projects]);

  useEffect(() => {
    const filteredProjects = [...leads]?.reverse() || [];
    const filteredEmpProjects = filteredProjects?.filter((proj) =>
      loggedEmp?.EmpGroups?.includes(proj?.groupid || proj?.AssignedGroup)
    );
    setFilteredLeads(filteredEmpProjects)
  }, [leads, loggedEmp, isErpPackage, assignedProjectsForErpL4])

  useEffect(() => {
    const filteredEmpGroups = data?.filter((grp) =>
      loggedEmp?.EmpGroups?.includes(grp?.groupid || grp?._id || grp?.newGroupName)
    );
    setFilteredEmpGroups(filteredEmpGroups)
  }, [data, group, loggedEmp, isErpPackage, assignedProjectsForErpL4, managerProjectsForErpPmDropdown])

  useEffect(() => {
    const filteredTraining = mytrainings?.trainings || [];
    const uniqueTraining = filteredTraining.filter(
      (t, i, arr) => i === arr.findIndex(x => x?._id === t?._id)
    );
    const sortedTraining = [...uniqueTraining].sort((a, b) =>
      new Date(b.createdAt) - new Date(a.createdAt)
    );

    const currentUserVisibleTraining = sortedTraining?.filter(
      (tra) => tra?.assignedto === loggedEmp?._id || tra?.assignedby === loggedEmp?._id
    );

    if (mytrainingOMMyManagement === "Assignment") {
      const managerSelfTraining = currentUserVisibleTraining?.filter((tra) => tra?.assignedto === loggedEmp?._id)
      setMyTrainingData((prev) => {
        const unsavedRows = (prev || []).filter((row) => !row?._id);
        return [...(managerSelfTraining || []), ...unsavedRows];
      })
      return;
    }

    setMyTrainingData((prev) => {
      const unsavedRows = (prev || []).filter((row) => !row?._id);
      return [...(currentUserVisibleTraining || []), ...unsavedRows];
    })
  }, [mytrainings, loggedEmp, mytrainingOMMyManagement])

  useEffect(() => {
    if (employees.length > 0) {

      if (loggedEmp?.EmpAuthLevel === "L0" || loggedEmp?.EmpAuthLevel === "L1") {
        const salesPerson = employees?.filter((emp) => (
          emp?.EmpAuthLevel === "L3"
        ));
        setFiltereedEmployees(salesPerson)
      } else if (loggedEmp?.EmpAuthLevel === "L3") {
        const managerPerson = employees?.filter((emp) => (
          emp?.EmpAuthLevel === "L4" && emp?.customRoles?.includes("project manager")
        ));
        const maangerWithSameGroup = managerPerson?.filter((emp) =>
          emp.EmpGroups?.some((group) => loggedEmp?.EmpGroups?.includes(group))
        );
        setFiltereedEmployees(maangerWithSameGroup)
      } else if (loggedEmp?.EmpAuthLevel === "L4" || loggedEmp?.customRoles?.includes("project manager")) {
        const operationPerson = employees?.filter((emp) => (
          emp?.EmpAuthLevel === "L4" && emp?.customRoles?.includes("operations")
        ));
        const operationWithSameGroup = operationPerson?.filter((emp) =>
          emp.EmpGroups?.some((group) => loggedEmp?.EmpGroups?.includes(group))
        );
        const operationWithSameServiceType = operationWithSameGroup.filter((emp) => emp.servicetype === loggedEmp?.servicetype)
        setFiltereedEmployees(operationWithSameServiceType)
      } else if (loggedEmp?.EmpAuthLevel === "L3") {
        const managerPerson = employees?.filter((emp) => (
          emp?.EmpAuthLevel === "L4" && emp?.customRoles?.includes("project manager")
        ));
        const maangerWithSameGroup = managerPerson?.filter((emp) =>
          emp.EmpGroups?.some((group) => loggedEmp?.EmpGroups?.includes(group))
        );
        setFiltereedEmployees(maangerWithSameGroup)
      } else if (loggedEmp?.EmpAuthLevel === "L4" || loggedEmp?.customRoles?.includes("project manager")) {
        const operationPerson = employees?.filter((emp) => (
          emp?.EmpAuthLevel === "L4" && emp?.customRoles?.includes("operations")
        ));
        const operationWithSameGroup = operationPerson?.filter((emp) =>
          emp.EmpGroups?.some((group) => loggedEmp?.EmpGroups?.includes(group))
        );
        const operationWithSameServiceType = operationWithSameGroup.filter((emp) => emp.servicetype === loggedEmp?.servicetype)
        setFiltereedEmployees(operationWithSameServiceType)
      } else if (loggedEmp?.EmpAuthLevel === "L4" && loggedEmp?.customRoles?.includes("operations")) {
        // Ops users should be able to assign trainings to other ops users (same group/service type),
        // not only to self.
        const operationPerson = employees?.filter((emp) => (
          emp?.EmpAuthLevel === "L4" && emp?.customRoles?.includes("operations")
        ));
        const operationWithSameGroup = operationPerson?.filter((emp) =>
          emp.EmpGroups?.some((group) => loggedEmp?.EmpGroups?.includes(group))
        );
        const operationWithSameServiceType = operationWithSameGroup.filter((emp) => emp.servicetype === loggedEmp?.servicetype)
        setFiltereedEmployees(operationWithSameServiceType)
      }
    }

  }, [employees, loggedEmp])

  const [selectedProject, setSelectedProject] = useState("")
  const [, setselectedAssigedTo] = useState(null);

  const fieldLabels = {
    groupId: "Group",
    projectname: "Project",
    trainingname: "Training Name",
    assignedto: "Assigned To",
    duedate: "Due Date",
  };

  const validateTrainingData = (data) => {
    const requiredFields = Object.keys(fieldLabels);

    const isValidValue = (value) => {
      if (value === undefined || value === null || value === "") return false;

      if (value instanceof Date) {
        return !isNaN(value.getTime());
      }

      if (typeof value === "object" && Object.keys(value).length === 0) return false;

      return true;
    };

    for (const item of data) {
      for (const field of requiredFields) {
        if (!isValidValue(item[field])) {
          return {
            valid: false,
            training: item.trainingname || "",
            field,
            label: fieldLabels[field] // return friendly label
          };
        }
      }
    }

    return { valid: true };
  };

  const handleTrainingSubmit = async () => {
    if (isViewOnly) return;
    // Saved rows may not carry `projectname` in state, but we still render the correct project via quotation/ids.
    // Normalize it before validation so "Please Fill Project" is not shown incorrectly.
    const normalizedTrainingData = myTrainingData.map((item) => {
      if (item?.projectname) return item;

      if (isErpPackage) {
        const projectById = projects.find(
          (project) => String(project?._id || "") === String(item?.projectid || "")
        );
        const projectByQuotation = projects.find(
          (project) => project?.quotationId === item?.quotationId
        );
        const leadByQuotation = leads.find(
          (lead) => lead?.quotationId === item?.quotationId
        );
        return {
          ...item,
          projectname:
            projectById?.ProjectName ||
            projectByQuotation?.ProjectName ||
            leadByQuotation?.ProjectName ||
            "",
        };
      }

      if (isCrmPackage) {
        const leadById = (filteredLeads || []).find(
          (lead) => lead?._id === item?.leadid
        );
        const leadByQuotation = (filteredLeads || []).find(
          (lead) => lead?.quotationId === item?.quotationId
        );
        const leadByIdFallback = (leads || []).find(
          (lead) => lead?._id === item?.leadid
        );
        const leadByQuotationFallback = (leads || []).find(
          (lead) => lead?.quotationId === item?.quotationId
        );
        return {
          ...item,
          projectname:
            leadById?.ProjectName ||
            leadByQuotation?.ProjectName ||
            leadByIdFallback?.ProjectName ||
            leadByQuotationFallback?.ProjectName ||
            "",
        };
      }

      return item;
    });

    const check = validateTrainingData(normalizedTrainingData);
    if (!check.valid) {
      enqueueSnackbar(
        `Please Fill ${check.label}`,
        { variant: "error" }
      );
      return;
    }
    const getTrainingTypeFlag = (projectStatus) => {
      const normalizedStatus = String(projectStatus || "").trim().toLowerCase();
      const isQuotedTraining =
        normalizedStatus === "project request outstanding" ||
        normalizedStatus === "project requested" ||
        normalizedStatus === "response received";

      return isQuotedTraining
        ? { isTrainingQuoted: true }
        : { isTrainingActual: true };
    };

    const priorAssignmentsById = new Map();
    (myTrainingData || []).forEach((row) => {
      if (row?._id) {
        priorAssignmentsById.set(String(row._id), {
          assignedto: row?.assignedto,
          projectid: row?.projectid,
        });
      }
    });

    const records = normalizedTrainingData.map(item => {
      const matchedProjectById = projects.find(
        (proj) => String(proj?._id || "") === String(item?.projectid || "")
      );
      const matchedLeadById = filteredLeads.find((lead) => lead?._id === item?.leadid);
      const matchedLeadProject = matchedLeadById || filteredLeads.find(
        (lead) => lead?.ProjectName === item.projectname
      );
      const matchedProjectByName = projects.find(
        (proj) => proj?.ProjectName === item.projectname
      );
      const matchedProject = matchedProjectById || matchedProjectByName;
      const projectStatus =
        item?.project?.SalesPersonStatus ||
        item?.project?.Status ||
        matchedLeadProject?.SalesPersonStatus ||
        matchedLeadProject?.Status ||
        matchedProject?.SalesPersonStatus ||
        matchedProject?.Status;

      return {
        _id: item._id || null,
        groupId: item.groupId,
        projectname: item.projectname,
        trainingname: item.trainingname,
        assignedto: item.assignedto,
        duedate: item.duedate,
        enddate: item.enddate || null,
        linktotraining: item.linktotraining,
        trainingcost: Number(item.trainingcost),
        status: item.status,
        ...(isErpPackage && (loggedEmp?.EmpAuthLevel === "L3" || loggedEmp?.EmpAuthLevel === "L4")
          ? {
            projectid: resolveErpProjectIdForAssignee(item, item?.assignedto) || item?.projectid || matchedProject?._id || "",
            quotationId: item?.quotationId || matchedProject?.quotationId || "",
          }
          : {}),
        ...(isCrmPackage
          ? {
            leadid: item?.leadid || matchedLeadProject?._id || null,
            quotationId: item?.quotationId || matchedLeadProject?.quotationId || "",
          }
          : {}),
        ...getTrainingTypeFlag(projectStatus),
      };
    });

    /** When assignee/project change, reconcile the OLD bucket too (clears orphaned training-expense markers). */
    const extraExpensePairsFromReassignment = [];
    records.forEach((rec) => {
      if (!rec?._id) return;
      const prev = priorAssignmentsById.get(String(rec._id));
      if (
        prev &&
        prev.assignedto != null &&
        prev.projectid &&
        (String(prev.assignedto) !== String(rec.assignedto) ||
          String(prev.projectid) !== String(rec.projectid))
      ) {
        extraExpensePairsFromReassignment.push({
          assigneeEmpId: String(prev.assignedto),
          erpProjectId: String(prev.projectid),
        });
      }
    });

    let trainingSaveSucceeded = false;
    const toUpdate = records.filter(r => r._id);
    const toCreate = records.find(r => !r._id);

    setIsLoading(true);

    try {
      if (toCreate) {
        try {
          const response = await axiosInstance.post(
            `${config.backendUrl}/my-training/create`,
            toCreate
          );
          const trainingId = response?.data?.training?._id;
          handleFileUpload(trainingId, selectedFile);
          setMyTrainingData((prev) => (prev || []).filter((row) => row?._id));

          enqueueSnackbar("Trainings Added Successfully", { variant: "success" });
          trainingSaveSucceeded = true;
        } catch (err) {
          console.error("Create error:", err);
        }
      }
      if (toUpdate.length > 0) {
        try {
          await Promise.all(
            toUpdate.map(item =>
              dispatch(updateTraining({ id: item._id, payload: item }))
            )
          );
          enqueueSnackbar("Trainings Updated Successfully", { variant: "success" });
          trainingSaveSucceeded = true;
        } catch (err) {
          console.error("Update error:", err);
        }
      }

      if (trainingSaveSucceeded) {
        try {
          await dispatch(getMyTrainings()).unwrap();
          await dispatch(
            reconcileTrainingLinkedOtherExpenses({ extraPairs: extraExpensePairsFromReassignment })
          ).unwrap();
        } catch (syncErr) {
          console.error("Training / Other Expenses sync failed:", syncErr);
        }
      }
    } finally {
      setIsLoading(false);
      if (!trainingSaveSucceeded) {
        dispatch(getMyTrainings());
      }
    }
  };

  const handleFileUpload = async (id, files) => {
    if (!files?.length) return;

    const selectedCategory = files[0]?.selectedCategory; // assuming same category for all
    const rawFiles = files.map(f => f.file);

    try {
      await dispatch(
        uploadTrainingFile({
          trainingId: id,
          selectedCategory,
          files: rawFiles
        })
      ).unwrap();
      enqueueSnackbar(`Files uploaded successfully`, { variant: "success" });
    } catch (err) {
      console.error(err);
    }
  }

  useEffect(() => {
    dispatch(fetchAllProjects())
  }, [dispatch])

  const handleGroupName = useCallback(
    (groupId) => {
      const GroupName = group.find((g) => g._id === groupId);
      return GroupName ? GroupName.newGroupName : "Select";
    },
    [group] // dependencies
  );

  const handleAssignBy = useCallback(
    (assignedby) => {
      if (!assignedby) {
        return (loggedEmp?.EmpAuthLevel === "L0" || loggedEmp?.EmpAuthLevel === "L1") ? "Self" : "";
      }
      const assignEmp = employees.find((e) => e._id === assignedby);
      if (!assignEmp) return "";
      return assignEmp?.EmpEmail === loggedEmp?.EmpEmail
        ? "Self"
        : `${assignEmp?.EmpFirstName ?? ""} ${assignEmp?.EmpLastName ?? ""}`;
    },
    [employees, loggedEmp]
  );

  const handleAssignTo = useCallback(
    (assignedto) => {
      const assignEmp = employees.find((e) => e._id === assignedto);

      if (!assignEmp) return "Select";

      if (assignEmp.EmpEmail === loggedEmp?.EmpEmail) return "Self";

      return `${assignEmp?.EmpFirstName ?? ""} ${assignEmp?.EmpLastName ?? ""}`.trim();
    },
    [employees, loggedEmp]
  );

  const resolveErpProjectIdForAssignee = useCallback(
    (trainingRow, assigneeId) => {
      if (!isErpPackage) return trainingRow?.projectid || "";

      const assignee = employees.find((emp) => emp?._id === assigneeId);
      const assigneeEmail = String(assignee?.EmpEmail || "").trim().toLowerCase();
      const quotationId = String(trainingRow?.quotationId || "").trim();
      const projectName = String(trainingRow?.projectname || "").trim().toLowerCase();

      const matchingProjects = (projects || []).filter((proj) => {
        const projQuotationId = String(proj?.quotationId || "").trim();
        const projName = String(proj?.ProjectName || "").trim().toLowerCase();
        if (quotationId) return projQuotationId === quotationId;
        return projectName && projName === projectName;
      });

      if (!matchingProjects.length) return trainingRow?.projectid || "";
      if (!assigneeEmail) return matchingProjects[0]?._id || trainingRow?.projectid || "";

      const assigneeMatchedProject = matchingProjects.find((proj) =>
        (proj?.Assignedperson || []).some((person) =>
          String(person?.email || person?.EmpEmail || "").trim().toLowerCase() === assigneeEmail
        )
      );

      return assigneeMatchedProject?._id || matchingProjects[0]?._id || trainingRow?.projectid || "";
    },
    [isErpPackage, employees, projects]
  );

  const normalizeTrainingEmail = useCallback((value) => {
    return String(value ?? "")
      .trim()
      .toLowerCase();
  }, []);

  /** All Assignedperson-like arrays on a lead/project row (handles API casing differences). */
  const flattenAssignedpersonLike = useCallback((rowLike) => {
    if (!rowLike || typeof rowLike !== "object") return [];
    const rawArrays = [
      rowLike.Assignedperson,
      rowLike.assignedperson,
      rowLike.AssignedPerson,
      rowLike.AssignedPeople,
      rowLike.assignedPeople,
    ].filter((x) => Array.isArray(x));
    const out = [];
    rawArrays.forEach((arr) => {
      arr.forEach((entry) => {
        if (entry != null) out.push(entry);
      });
    });
    const managerActionRows = Array.isArray(rowLike.ProjectManagerAction)
      ? rowLike.ProjectManagerAction
      : Array.isArray(rowLike.projectManagerAction)
        ? rowLike.projectManagerAction
        : [];
    managerActionRows.forEach((entry) => {
      const assigned = Array.isArray(entry?.AssignedPerson)
        ? entry.AssignedPerson
        : Array.isArray(entry?.assignedPerson)
          ? entry.assignedPerson
          : [];
      assigned.forEach((person) => {
        if (!person || typeof person !== "object") return;
        out.push({
          ...person,
          manageraction:
            person.manageraction ??
            person.managerAction ??
            entry?.manageraction ??
            entry?.managerAction ??
            entry?.action ??
            entry?.status,
          taskStatus:
            person.taskStatus ??
            person.taskstatus ??
            entry?.taskStatus ??
            entry?.taskstatus,
          projecttracktaskStatus:
            person.projecttracktaskStatus ??
            person.projectTrackTaskStatus ??
            entry?.projecttracktaskStatus ??
            entry?.projectTrackTaskStatus,
          salespersonstatus:
            person.salespersonstatus ??
            person.salesPersonStatus ??
            entry?.salespersonstatus ??
            entry?.salesPersonStatus,
          salespersonaction:
            person.salespersonaction ??
            person.salesPersonAction ??
            entry?.salespersonaction ??
            entry?.salesPersonAction,
        });
      });
    });
    return out;
  }, []);

  const normTrainingName = useCallback((value) => {
    return String(value ?? "")
      .trim()
      .toLowerCase()
      .replace(/\s+/g, " ");
  }, []);

  /** Match roster person to employee (email, id, or display name) — SP rows often only have `name`. */
  const personMatchesTrainingEmployee = useCallback(
    (person, emp) => {
      if (!person || !emp) return false;
      const eEmail = normalizeTrainingEmail(emp.EmpEmail);
      const pEmail = normalizeTrainingEmail(
        person.email || person.EmpEmail || person.employeeEmail || person?.employeeId?.EmpEmail
      );
      if (eEmail && pEmail && eEmail === pEmail) return true;

      const eId = String(emp._id || emp.id || "").trim();
      const pId = String(
        person._id ||
          person.userId ||
          person.id ||
          person.employeeId?._id ||
          person.employeeId?.id ||
          ""
      ).trim();
      if (eId && pId && eId === pId) return true;

      const eName = normTrainingName(`${emp.EmpFirstName || ""} ${emp.EmpLastName || ""}`);
      const pName = normTrainingName(
        person.name ||
          person.fullName ||
          `${person.EmpFirstName || person?.employeeId?.EmpFirstName || ""} ${person.EmpLastName || person?.employeeId?.EmpLastName || ""}`
      );
      if (!eName || !pName) return false;
      if (pName === eName) return true;
      return pName.includes(eName) || eName.includes(pName);
    },
    [normalizeTrainingEmail, normTrainingName]
  );

  /** Sales (SP): only allow training assignment after the manager has accepted the lead/project task. */
  const isManagerAcceptedForSpTraining = useCallback((person) => {
    if (!person || typeof person !== "object") return false;
    const acceptedLike = (value) => {
      const v = String(value ?? "").trim().toLowerCase();
      if (!v) return false;
      return (
        v === "submit" ||
        v === "accept" ||
        v === "accepted" ||
        v === "approved" ||
        v === "project accepted" ||
        v === "project approved" ||
        v.includes("accept") ||
        v.includes("approved")
      );
    };
    const values = [
      person.taskStatus,
      person.taskstatus,
      person.projecttracktaskStatus,
      person.projectTrackTaskStatus,
      person.operationaction,
      person.operationAction,
      person.manageraction,
      person.managerAction,
      person.ProjectManagerAction,
      person.projectManagerAction,
      person.ProjectManagerStatus,
      person.projectManagerStatus,
      person.salespersonstatus,
      person.salesPersonStatus,
      person.salespersonaction,
      person.salesPersonAction,
      person.status,
      person.action,
    ];
    if (values.some(acceptedLike)) return true;
    return false;
  }, []);

  const isManagerRejectedForSpTraining = useCallback((person) => {
    if (!person || typeof person !== "object") return false;
    const rejectedLike = (value) => {
      const v = String(value ?? "").trim().toLowerCase();
      if (!v) return false;
      return (
        v === "reject" ||
        v === "rejected" ||
        v === "cancel" ||
        v === "cancelled" ||
        v === "canceled" ||
        v.includes("reject") ||
        v.includes("cancel")
      );
    };
    return [
      person.taskStatus,
      person.taskstatus,
      person.projecttracktaskStatus,
      person.projectTrackTaskStatus,
      person.operationaction,
      person.operationAction,
      person.manageraction,
      person.managerAction,
      person.ProjectManagerAction,
      person.projectManagerAction,
      person.ProjectManagerStatus,
      person.projectManagerStatus,
      person.salespersonstatus,
      person.salesPersonStatus,
      person.salespersonaction,
      person.salesPersonAction,
      person.status,
      person.action,
    ].some(rejectedLike);
  }, []);

  /** Emails listed as assigned / forwarded managers on a row. */
  const collectAssignedManagerEmails = useCallback(
    (rowLike) => {
      const set = new Set();
      if (!rowLike || typeof rowLike !== "object") return set;
      const arrays = [
        rowLike.AssignedManagerEmail,
        rowLike.AssignedManagerEmails,
        rowLike.assignedManagerEmail,
        rowLike.assignedManagerEmails,
      ].filter(Array.isArray);
      arrays.forEach((arr) => {
        arr.forEach((e) => {
          const n = normalizeTrainingEmail(e);
          if (n) set.add(n);
        });
      });
      return set;
    },
    [normalizeTrainingEmail]
  );

  const mergeUniqueProjectLike = useCallback((acc, candidate) => {
    if (!candidate) return acc;
    const q = String(candidate?.quotationId || "").trim();
    const id = String(candidate?._id || candidate?.id || "").trim();
    const nm = String(candidate?.ProjectName || "").trim().toLowerCase();
    const exists = acc.some((p) => {
      const pq = String(p?.quotationId || "").trim();
      const pid = String(p?._id || p?.id || "").trim();
      if (q && pq === q) return true;
      if (id && pid === id) return true;
      if (nm && String(p?.ProjectName || "").trim().toLowerCase() === nm) {
        if (q && pq && q !== pq) return false;
        if (pq && q && q !== pq) return false;
        return true;
      }
      return false;
    });
    if (!exists) acc.push(candidate);
    return acc;
  }, []);

  /** Pull every ERP project row tied to a quotation (CRM lead → project carries Assignedperson). */
  const mergeProjectsByQuotationInto = useCallback(
    (acc, quotationId) => {
      const q = String(quotationId || "").trim();
      if (!q) return;
      const pool = [
        ...(projects || []),
        ...(assignedProjectsForErpL4 || []),
        ...(managerProjectsForErpPmDropdown || []),
      ];
      pool.forEach((proj) => {
        if (String(proj?.quotationId || "").trim() === q) {
          mergeUniqueProjectLike(acc, proj);
        }
      });
    },
    [projects, assignedProjectsForErpL4, managerProjectsForErpPmDropdown, mergeUniqueProjectLike]
  );

  const accumulatePeopleFromAssignedLike = useCallback(
    (src, emailSet, nameSet) => {
      if (!src) return;
      const rawArrays = [
        src.Assignedperson,
        src.assignedperson,
        src.AssignedPerson,
        src.AssignedPeople,
        src.assignedPeople,
      ].filter((x) => Array.isArray(x));

      const pushEmailName = (emailRaw, nameRaw) => {
        const email = normalizeTrainingEmail(emailRaw);
        const name = String(nameRaw || "").trim().toLowerCase();
        if (email) emailSet.add(email);
        if (name) nameSet.add(name);
      };

      rawArrays.forEach((arr) => {
        arr.forEach((entry) => {
          if (entry == null) return;
          if (typeof entry === "string") {
            const emp = (employees || []).find(
              (e) => String(e?._id) === String(entry) || String(e?.id) === String(entry)
            );
            if (emp) {
              pushEmailName(emp.EmpEmail, `${emp.EmpFirstName || ""} ${emp.EmpLastName || ""}`);
            }
            return;
          }
          const nested = entry?.employeeId;
          if (nested && typeof nested === "object") {
            pushEmailName(
              nested.EmpEmail || entry.email,
              entry.name || `${nested.EmpFirstName || ""} ${nested.EmpLastName || ""}`
            );
            return;
          }
          pushEmailName(
            entry.email || entry.EmpEmail || entry?.employeeEmail,
            entry.name ||
              `${entry.EmpFirstName || ""} ${entry.EmpLastName || ""}`.trim() ||
              entry?.fullName
          );
        });
      });
    },
    [employees, normalizeTrainingEmail]
  );

  /** Resolve project/lead rows for the selected training row (quotationId, ids, name) so Assignedperson can be read. */
  const getSourcesForTrainingAssignments = useCallback(
    (training) => {
      if (!training) return [];
      const acc = [];
      const qId = String(training?.quotationId || "").trim();
      const pid = String(training?.projectid || "").trim();
      const lid = String(training?.leadid || "").trim();
      const pname = String(training?.projectname || "").trim().toLowerCase();

      const projectPools = [
        ...(projects || []),
        ...(assignedProjectsForErpL4 || []),
        ...(managerProjectsForErpPmDropdown || []),
      ];

      projectPools.forEach((proj) => {
        const pq = String(proj?.quotationId || "").trim();
        const pidp = String(proj?._id || proj?.id || "").trim();
        const pnp = String(proj?.ProjectName || "").trim().toLowerCase();
        let hit = false;
        if (qId && pq && pq === qId) hit = true;
        else if (pid && pidp && pidp === pid) hit = true;
        else if (!qId && pname && pnp && pnp === pname) hit = true;
        if (hit) mergeUniqueProjectLike(acc, proj);
      });

      const leadsPool = [...(filteredLeads || []), ...(leads || [])];
      leadsPool.forEach((lead) => {
        const lq = String(lead?.quotationId || "").trim();
        const lidL = String(lead?._id || lead?.id || "").trim();
        const lnp = String(lead?.ProjectName || "").trim().toLowerCase();
        let hit = false;
        if (qId && lq && lq === qId) hit = true;
        else if (lid && lidL && lidL === lid) hit = true;
        else if (!qId && pname && lnp && lnp === pname) hit = true;
        if (hit) mergeUniqueProjectLike(acc, lead);
      });

      if (training?.project) mergeUniqueProjectLike(acc, training.project);

      // CRM / quoted path: roster lives on ERP project rows with same quotationId as the lead.
      mergeProjectsByQuotationInto(acc, qId);
      [...acc].forEach((item) => {
        mergeProjectsByQuotationInto(acc, item?.quotationId);
      });

      return acc;
    },
    [
      projects,
      assignedProjectsForErpL4,
      managerProjectsForErpPmDropdown,
      filteredLeads,
      leads,
      mergeUniqueProjectLike,
      mergeProjectsByQuotationInto,
    ]
  );

  const isLoggedProjectManager = useMemo(() => {
    if (loggedEmp?.EmpAuthLevel !== "L4") return false;
    const roles = []
      .concat(loggedEmp?.customRoles || [])
      .map((r) => String(r || "").trim().toLowerCase());
    return roles.some(
      (r) =>
        r === "project manager" ||
        (r.includes("project") && r.includes("manager"))
    );
  }, [loggedEmp]);

  const isLoggedOperationsUser = useMemo(() => {
    // If the logged-in user is Operations (but not PM), we still allow assigning
    // to other operations users relevant to the selected lead/project.
    const fromEmployee = []
      .concat(loggedEmp?.customRoles || [])
      .map((r) => String(r || "").trim().toLowerCase());

    const fromStorageRaw = localStorage.getItem("Roles");
    let fromStorage = [];
    try {
      // Some envs store JSON array, some store comma-separated string.
      const parsed = JSON.parse(fromStorageRaw);
      if (Array.isArray(parsed)) {
        fromStorage = parsed.map((r) => String(r || "").trim().toLowerCase());
      } else if (typeof parsed === "string") {
        fromStorage = String(parsed).split(",").map((r) => r.trim().toLowerCase()).filter(Boolean);
      }
    } catch {
      fromStorage = String(fromStorageRaw || "")
        .split(",")
        .map((r) => r.trim().toLowerCase())
        .filter(Boolean);
    }

    const roles = [...fromEmployee, ...fromStorage].filter(Boolean);
    const isOps = roles.some((r) => r.includes("operation"));
    const isPm = roles.some((r) => r === "project manager" || (r.includes("project") && r.includes("manager")));
    return isOps && !isPm;
  }, [loggedEmp]);

  /** PM assignees for this lead/project (operations + managers, excluding self). */
  const getPmAssigneesForTrainingRow = useCallback(
    (training) => {
      const sources = getSourcesForTrainingAssignments(training);
      const emailSet = new Set();
      const nameSet = new Set();

      sources.forEach((src) => accumulatePeopleFromAssignedLike(src, emailSet, nameSet));

      if (!emailSet.size && !nameSet.size) return [];

      const empInRoster = (emp) => {
        const empEmail = normalizeTrainingEmail(emp?.EmpEmail);
        const empName = `${emp?.EmpFirstName || ""} ${emp?.EmpLastName || ""}`.trim().toLowerCase();
        return (
          (empEmail && emailSet.has(empEmail)) || (empName && nameSet.has(empName))
        );
      };

      const isOperationsLike = (emp) => {
        const roles = ([]).concat(emp?.customRoles || []).map((r) => String(r || "").toLowerCase());
        return roles.some((r) => r.includes("operation"));
      };

      const isProjectManagerLike = (emp) => {
        const roles = ([]).concat(emp?.customRoles || []).map((r) => String(r || "").toLowerCase());
        return roles.some(
          (r) => r === "project manager" || (r.includes("project") && r.includes("manager"))
        );
      };

      const pool = (employees || []).filter((emp) => {
        if (String(emp?._id) === String(loggedEmp?._id)) return false;
        if (!empInRoster(emp)) return false;
        return isOperationsLike(emp) || isProjectManagerLike(emp);
      });

      if (pool.length) {
        return [
          ...pool.filter(isOperationsLike),
          ...pool.filter((e) => !isOperationsLike(e)),
        ];
      }

      // Fallback: roster has people but roles are not tagged — still list roster except self.
      return (employees || []).filter((emp) => {
        if (String(emp?._id) === String(loggedEmp?._id)) return false;
        if (!empInRoster(emp)) return false;
        return true;
      });
    },
    [
      employees,
      getSourcesForTrainingAssignments,
      loggedEmp?._id,
      normalizeTrainingEmail,
      accumulatePeopleFromAssignedLike,
    ]
  );

  /** Ops assignees: Self + ONLY forwarded operations person for selected lead. */
  const getOpsAssigneesForTrainingRow = useCallback(
    (training) => {
      const sources = getSourcesForTrainingAssignments(training);
      const emailSet = new Set();
      const nameSet = new Set();
      sources.forEach((src) => accumulatePeopleFromAssignedLike(src, emailSet, nameSet));

      const isOperationsLike = (emp) => {
        const roles = ([]).concat(emp?.customRoles || []).map((r) => String(r || "").toLowerCase());
        return roles.some((r) => r.includes("operation"));
      };

      const isInRoster = (emp) => {
        const eEmail = normalizeTrainingEmail(emp?.EmpEmail);
        const eName = `${emp?.EmpFirstName || ""} ${emp?.EmpLastName || ""}`.trim().toLowerCase();
        return (eEmail && emailSet.has(eEmail)) || (eName && nameSet.has(eName));
      };

      // Prefer lead/project roster first (ensures "for that lead" behavior).
      const rosterOps = (employees || [])
        .filter((emp) => emp && String(emp?._id) !== String(loggedEmp?._id))
        .filter(isInRoster)
        .filter(isOperationsLike)
        .filter((emp) => !loggedEmp?.servicetype || emp?.servicetype === loggedEmp?.servicetype);

      if (rosterOps.length > 0) return rosterOps;

      // Fallback: if roster isn't present on lead/project payload, allow same group/service-type operations.
      return (filtereedEmployees || [])
        .filter((emp) => emp && String(emp?._id) !== String(loggedEmp?._id))
        .filter(isOperationsLike)
        .filter((emp) => emp.EmpGroups?.includes(training?.groupId));
    },
    [
      employees,
      filtereedEmployees,
      getSourcesForTrainingAssignments,
      loggedEmp?._id,
      loggedEmp?.servicetype,
      normalizeTrainingEmail,
      accumulatePeopleFromAssignedLike,
    ]
  );

  /** Manager assignees: ONLY forwarded Operations users from Project Requests row (deduped). */
  const getManagerForwardedOperationsForTrainingRow = useCallback(
    (training) => {
      if (!training) return [];

      const qId = String(training?.quotationId || "").trim();
      const projectId = String(training?.projectid || "").trim();
      const projectName = String(training?.projectname || "").trim().toLowerCase();

      // STEP 1: Match the EXACT Project Requests row for THIS manager card/service.
      // In Project Requests, assignments are scoped by `row.AssignedManagerEmail` (see `ResourcesDropdown.jsx`).
      const currentManagerEmail = String(localStorage.getItem("email") || "")
        .trim()
        .toLowerCase();

      const projectRequests = (projects || []).filter((p) => {
        if (!p) return false;
        const pq = String(p?.quotationId || "").trim();
        const pid = String(p?._id || p?.id || "").trim();
        const pn = String(p?.ProjectName || "").trim().toLowerCase();
        if (projectId && pid && pid === projectId) return true;
        if (qId && pq && pq === qId) return true;
        return projectName && pn === projectName;
      });

      const matchedProjectRequest =
        projectRequests.find((p) =>
          Array.isArray(p?.AssignedManagerEmail) &&
          p.AssignedManagerEmail.some(
            (e) => String(e || "").trim().toLowerCase() === currentManagerEmail
          )
        ) || projectRequests[0];

      // STEP 2: Reuse the SAME array/path used to render "Assign Task To Employees"
      const employeeList = Array.isArray(matchedProjectRequest?.Assignedperson)
        ? matchedProjectRequest.Assignedperson
        : Array.isArray(matchedProjectRequest?.assignedperson)
          ? matchedProjectRequest.assignedperson
          : [];

      // STEP 3: STRICT keep ONLY actual assigned employees for this manager card:
      // - remove Self/empty
      // - remove manager emails (AssignedManagerEmail) so managers never appear in Assign To
      const managerEmails = new Set(
        (Array.isArray(matchedProjectRequest?.AssignedManagerEmail) ? matchedProjectRequest.AssignedManagerEmail : [])
          .map((e) => String(e || "").trim().toLowerCase())
          .filter(Boolean)
      );

      const validEmployees = employeeList.filter((emp) => {
        const name = String(emp?.name || emp?.employeeName || emp?.userName || "").trim();
        const email = String(emp?.email || emp?.EmpEmail || emp?.employeeEmail || "").trim().toLowerCase();
        if (!name && !email) return false;
        if (name && name.toLowerCase() === "self") return false;
        if (email && email === currentManagerEmail) return false;
        if (email && managerEmails.has(email)) return false;
        return true;
      });

      // STEP 4: Resolve to employee records only to get `_id` (dropdown value).
      const resolved = validEmployees
        .map((p) => {
          const email = normalizeTrainingEmail(p?.email || p?.EmpEmail || p?.employeeEmail);
          if (!email) return null;
          return (employees || []).find((e) => normalizeTrainingEmail(e?.EmpEmail) === email) || null;
        })
        .filter(Boolean);

      // Dedupe by _id
      const seen = new Set();
      const unique = resolved.filter((e) => {
        const id = String(e?._id || "");
        if (!id || seen.has(id)) return false;
        seen.add(id);
        return true;
      });

      // MANDATORY DEBUG LOGS
      // eslint-disable-next-line no-console
      console.log("CURRENT SERVICE", String(matchedProjectRequest?.TypeService || ""));
      // eslint-disable-next-line no-console
      console.log("PROJECT ASSIGNMENTS", JSON.stringify(projectRequests, null, 2));
      // eslint-disable-next-line no-console
      console.log("MATCHED ASSIGNMENT", matchedProjectRequest);
      // eslint-disable-next-line no-console
      console.log("ASSIGNED EMPLOYEE", validEmployees);
      // eslint-disable-next-line no-console
      console.log(
        "FINAL OPTIONS",
        ["Self", ...unique.map((e) => `${e?.EmpFirstName || ""} ${e?.EmpLastName || ""}`.trim())]
      );

      return unique;
    },
    [projects, employees, normalizeTrainingEmail]
  );

  /** Sales (SP) assignees: ONLY managers forwarded for THIS lead/project (deduped). */
  const getSalesForwardedManagersForTrainingRow = useCallback(
    (training) => {
      if (!training) return [];

      // Resolve the ONE lead/project row for this training (avoid cross-lead leakage).
      const qId = String(training?.quotationId || "").trim();
      const leadId = String(training?.leadid || "").trim();
      const projectId = String(training?.projectid || "").trim();
      const projectName = String(training?.projectname || "").trim().toLowerCase();

      const leadsPool = [...(filteredLeads || []), ...(leads || [])];
      const exactLead = leadsPool.find((l) => {
        const lq = String(l?.quotationId || "").trim();
        const lid = String(l?._id || l?.id || "").trim();
        const lp = String(l?.projectid || l?.projectId || l?.ProjectId || "").trim();
        const ln = String(l?.ProjectName || "").trim().toLowerCase();
        if (qId && lq && lq === qId) return true;
        if (leadId && lid && lid === leadId) return true;
        if (projectId && (lp === projectId || lid === projectId)) return true;
        if (!qId && projectName && ln === projectName) return true;
        return false;
      });

      const extractForwardedManagersFromRow = (rowLike) => {
        // Return two lists:
        // - emails: Set<string>
        // - objects: [{email?, name?, id?}]
        const emails = new Set();
        const objects = [];

        if (!rowLike || typeof rowLike !== "object") return { emails, objects };

        const pushEmail = (e) => {
          const email = normalizeTrainingEmail(e);
          if (email) emails.add(email);
        };
        const pushObj = (o) => {
          if (!o || typeof o !== "object") return;
          const email = normalizeTrainingEmail(o.email || o.EmpEmail || o.employeeEmail || o?.employeeId?.EmpEmail);
          const name = String(
            o.name ||
              o.fullName ||
              `${o.EmpFirstName || o?.employeeId?.EmpFirstName || ""} ${o.EmpLastName || o?.employeeId?.EmpLastName || ""}`
          ).trim();
          const id = o._id || o.id || o?.employeeId?._id || o?.employeeId?.id;
          objects.push({ email, name, id });
          if (email) emails.add(email);
        };

        // 1) Most common: AssignedManagerEmail: string[]
        const assignedManagerEmailArrays = [
          rowLike.AssignedManagerEmail,
          rowLike.AssignedManagerEmails,
          rowLike.assignedManagerEmail,
          rowLike.assignedManagerEmails,
        ].filter(Array.isArray);
        assignedManagerEmailArrays.forEach((arr) => arr.forEach(pushEmail));

        // 2) Arrays of manager objects (various guessed keys)
        const objectArrays = [
          rowLike.forwardedManagers,
          rowLike.forwarded_to,
          rowLike.forwardedUsers,
          rowLike.assignedManagers,
          rowLike.managers,
          rowLike.managerData,
          rowLike.AssignedManager,
          rowLike.AssignedManagers,
          rowLike.sp_forwarded_to,
        ].filter(Array.isArray);
        objectArrays.forEach((arr) => arr.forEach(pushObj));

        // 3) Assignedperson / assignedperson rows: forwarded and/or accepted managers (multi-shape API)
        const managerEmailSet = collectAssignedManagerEmails(rowLike);
        const assignedRows = flattenAssignedpersonLike(rowLike);
        assignedRows.forEach((p) => {
          if (!p || typeof p !== "object") return;
          const action = String(p?.manageraction || p?.managerAction || "").trim().toLowerCase();
          const pEmail = normalizeTrainingEmail(p?.email || p?.EmpEmail || p?.employeeEmail || p?.employeeId?.EmpEmail);
          const accepted = isManagerAcceptedForSpTraining(p);
          if (action === "forward" || action === "forwarded") {
            pushEmail(p?.email || p?.EmpEmail || p?.employeeEmail || p?.employeeId?.EmpEmail);
            pushObj(p);
            return;
          }
          if (accepted && pEmail && (managerEmailSet.has(pEmail) || emails.has(pEmail))) {
            pushObj(p);
            pushEmail(p?.email || p?.EmpEmail || p?.employeeEmail || p?.employeeId?.EmpEmail);
            return;
          }
          if (accepted && pEmail) {
            pushObj(p);
            pushEmail(p?.email || p?.EmpEmail || p?.employeeEmail || p?.employeeId?.EmpEmail);
          }
        });

        // 4) ProjectManagerAction style structures (if present)
        const pma = Array.isArray(rowLike?.ProjectManagerAction) ? rowLike.ProjectManagerAction : [];
        pma.forEach((entry) => {
          if (!entry) return;
          const ap = Array.isArray(entry.AssignedPerson) ? entry.AssignedPerson : [];
          ap.forEach((p) => {
            pushEmail(p?.email || p?.EmpEmail || p?.employeeEmail);
            pushObj(p);
          });
        });

        return { emails, objects };
      };

      // Build from ONLY the exact lead row, not merged sources.
      const { emails: forwardedEmailsFromLead, objects: forwardedObjectsFromLead } =
        extractForwardedManagersFromRow(exactLead);

      // If the lead doesn't carry it, sometimes the ERP project row does (still row-specific via quotationId/projectId).
      const projectPool = (projects || []).filter((p) => {
        if (!p) return false;
        const pq = String(p?.quotationId || "").trim();
        const pid = String(p?._id || p?.id || "").trim();
        const pn = String(p?.ProjectName || "").trim().toLowerCase();
        if (qId && pq && pq === qId) return true;
        if (projectId && pid && pid === projectId) return true;
        if (!qId && projectName && pn === projectName) return true;
        return false;
      });
      const forwardedEmailsFromProjects = new Set();
      const forwardedObjectsFromProjects = [];
      projectPool.forEach((p) => {
        const { emails, objects } = extractForwardedManagersFromRow(p);
        objects.forEach((o) => forwardedObjectsFromProjects.push(o));
        emails.forEach((e) => forwardedEmailsFromProjects.add(e));
      });

      const candidateEmails = new Set([
        ...Array.from(forwardedEmailsFromLead),
        ...Array.from(forwardedEmailsFromProjects),
      ]);

      const isProjectManagerLike = (emp) => {
        const roles = ([]).concat(emp?.customRoles || []).map((r) => String(r || "").toLowerCase());
        return roles.some((r) => r.includes("project") && r.includes("manager"));
      };

      let pool = (employees || [])
        .filter((emp) => emp && String(emp?._id) !== String(loggedEmp?._id))
        .filter((emp) => String(emp?.EmpAuthLevel || "") === "L4")
        .filter((emp) => {
          // Prefer PM role if present; if roles missing, still allow L4 matches.
          return isProjectManagerLike(emp) || !(emp?.customRoles?.length);
        })
        .filter((emp) => {
          const e = normalizeTrainingEmail(emp?.EmpEmail);
          return e && candidateEmails.has(e);
        });

      // Deduplicate by _id
      const seen = new Set();
      pool = pool.filter((e) => {
        const id = String(e?._id || "");
        if (!id || seen.has(id)) return false;
        seen.add(id);
        return true;
      });

      // STEP 1 logs (as requested)
      // eslint-disable-next-line no-console
      console.log("TRAINING ROW", training);
      // eslint-disable-next-line no-console
      console.log("PROJECT DATA", training?.project);
      // eslint-disable-next-line no-console
      console.log("FORWARDED MANAGERS", {
        leadForwardedEmails: Array.from(forwardedEmailsFromLead),
        projectForwardedEmails: Array.from(forwardedEmailsFromProjects),
        leadForwardedObjects: forwardedObjectsFromLead,
        projectForwardedObjects: forwardedObjectsFromProjects,
      });
      // eslint-disable-next-line no-console
      console.log("FULL OBJECT", JSON.stringify(training, null, 2));
      // eslint-disable-next-line no-console
      console.log("[MyTrainings][SP AssignTo] FINAL", {
        trainingKey: { qId, leadId, projectId, projectName },
        leadMatched: exactLead,
        matchedProjects: projectPool,
        finalCandidateEmails: Array.from(candidateEmails),
        finalOptions: pool.map((e) => ({ id: e._id, email: e.EmpEmail, name: `${e.EmpFirstName} ${e.EmpLastName}` })),
      });

      // Deduplicate by _id
      return pool;
    },
    [
      employees,
      loggedEmp?._id,
      normalizeTrainingEmail,
      filteredLeads,
      leads,
      projects,
      flattenAssignedpersonLike,
      collectAssignedManagerEmails,
      isManagerAcceptedForSpTraining,
    ]
  );

  const isProjectMarkedComplete = useCallback(
    (candidateProject) => {
      const quotationId = String(candidateProject?.quotationId || "").trim();
      const projectName = String(candidateProject?.ProjectName || candidateProject?.projectname || "").trim().toLowerCase();
      const matchingProjects = (projects || []).filter((proj) => {
        const projQuotationId = String(proj?.quotationId || "").trim();
        const projName = String(proj?.ProjectName || "").trim().toLowerCase();
        if (quotationId) return projQuotationId === quotationId;
        return projectName && projName === projectName;
      });

      return matchingProjects.some((proj) =>
        (proj?.Assignedperson || []).some(
          (person) => String(person?.salespersonstatus || "").trim().toLowerCase() === "project complete"
        )
      );
    },
    [projects]
  );

  const handleNewTrainingRow = () => {
    if (isViewOnly) return;
    const unsaved = myTrainingData.filter(item => !item._id);
    if (unsaved.length > 0) {
      const trainingNames = unsaved.map(t => t.trainingname || " ").join(", ");
      enqueueSnackbar(`Please Save Training Details ${trainingNames}`, {
        variant: "error",
      });
      return;
    }
    setCurrentPage(1)
    setMyTrainingData([
      ...myTrainingData, // Spread the existing array first
      {
        groupId: "",
        projectname: "",
        projectid: "",
        leadid: "",
        quotationId: "",
        trainingname: "",
        assignedto: "",
        duedate: "",
        enddate: "",
        linktotraining: "",
        trainingcost: "",
        status: "",
      },
    ]);
    setTimeout(() => {
      if (tableScrollRef.current) {
        tableScrollRef.current.scrollTop = tableScrollRef.current.scrollHeight;
      }
    }, 0);
  };

  const [showsubmit, setShowSubmit] = useState([])
  const [assignTOBoolean, setAssignTOBoolean] = useState([])
  const isCrmL3Sales = isCrmPackage && loggedEmp?.EmpAuthLevel === "L3";

  const confirmDelete = async () => {
    if (isViewOnly) return;
    if (!trainingID) {
      setMyTrainingData(prevData => prevData.filter((_, i) => i !== trainingindex));
      setTrainingID()
      setIsModal(false)
      enqueueSnackbar("Training Deleted Successfully!", {
        variant: "success",
      });
    } else {
      const deletedRowSnapshot = myTrainingData[trainingindex];
      const extraExpensePairsFromDelete = [];
      if (deletedRowSnapshot?.assignedto != null && deletedRowSnapshot?.projectid) {
        extraExpensePairsFromDelete.push({
          assigneeEmpId: String(deletedRowSnapshot.assignedto),
          erpProjectId: String(deletedRowSnapshot.projectid),
        });
      }
      setIsLoading(true);
      try {
        await dispatch(deleteTraining(trainingID));
        await dispatch(getMyTrainings()).unwrap();
        try {
          await dispatch(
            reconcileTrainingLinkedOtherExpenses({ extraPairs: extraExpensePairsFromDelete })
          ).unwrap();
        } catch (syncErr) {
          console.error("Training / Other Expenses sync failed:", syncErr);
        }
        enqueueSnackbar("Training Deleted Successfully!", {
          variant: "success",
        });
      } catch (error) {
        console.error("Failed to create task:", error);
        dispatch(getMyTrainings());
      } finally {
        setIsLoading(false);
        setTrainingID()
        setIsModal(false)
      }
    }
  };

  const [itemsPerPage] = useState(10);

  const [trainingRow, setTrainingRow] = useState(null);
  const [popupProject, setPopupProject] = useState(false);
  const [openDropdownIndex, setOpenDropdownIndex] = useState(false);

  const { uploadedData } = useSelector((s) => s.myTrainingFileUpload);

  const getTrainingFileData = useCallback((Id) => {
    if (!Id) return;
    dispatch(getTrainingFiles(Id));
  }, [dispatch]);


  useEffect(() => {
    // if uploadedData is null, undefined, 0, "" → set empty array
    if (!uploadedData) {
      setSelectedFile([]);
      return;
    }
    // if it's already an array
    if (Array.isArray(uploadedData)) {
      setSelectedFile(uploadedData);
      return;
    }
    // if backend returned a single file object
    setSelectedFile([uploadedData]);
  }, [uploadedData]);

  const [searchQuery, setSearchQuery] = useState("");

  const getDisplayProjectName = useCallback(
    (training) => {
      if (isCrmPackage) {
        const leadById = filteredLeads.find((lead) => lead?._id === training?.leadid);
        return leadById?.ProjectName || training?.projectname || " ";
      }

      if (isErpPackage) {
        const projectById = projects.find(
          (project) => String(project?._id || "") === String(training?.projectid || "")
        );
        const projectByQuotation = projects.find(
          (project) => project?.quotationId === training?.quotationId
        );
        const leadByQuotation = filteredLeads.find(
          (lead) => lead?.quotationId === training?.quotationId
        );
        return projectById?.ProjectName || projectByQuotation?.ProjectName || leadByQuotation?.ProjectName || training?.projectname || " ";
      }

      return training?.projectname || " ";
    },
    [filteredLeads, isCrmPackage, isErpPackage, projects]
  );

  const handleSearchInputChange = (e) => {
    const query = e.target.value;
    const lowerQuery = query.replace(/,/g, '').toLowerCase();

    setSearchQuery(lowerQuery);
    setCurrentPage(1);
  };

  const searchedTraining = useMemo(() => {
    const rawQuery = searchQuery.toLowerCase().trim();
    const normalizedQuery = rawQuery.replace(/\//g, "-"); // Convert 06/11 to 06-11 for flexible date matching
    const formatDate = formatDateByCountryRef.current;

    return myTrainingData.filter((item) => {
      // Convert due date
      const dueDate = new Date(item.duedate);
      const dueDateStr1 = isNaN(dueDate) ? "" : formatDate(dueDate);
      const endDate = new Date(item.enddate);
      const endDateStr1 = isNaN(endDate) ? "" : formatDate(endDate);

      // Convert training cost to string for comparison
      const trainingCostStr = item.trainingcost?.toString() || "";
      const groupName = handleGroupName(item.groupId)?.toLowerCase() || "";
      const assignedToName = handleAssignTo(item.assignedto)?.toLowerCase() || "";
      const assignedbyName = handleAssignBy(item.assignedby)?.toLowerCase() || "";

      return (
        item.projectname?.toLowerCase().includes(normalizedQuery) ||
        item.trainingname?.toLowerCase().includes(normalizedQuery) ||
        item.status?.toLowerCase().includes(normalizedQuery) ||
        item.linktotraining?.toLowerCase().includes(normalizedQuery) ||
        trainingCostStr.includes(normalizedQuery) ||
        dueDateStr1.includes(rawQuery) ||
        endDateStr1.includes(rawQuery) ||
        assignedToName.includes(normalizedQuery) ||
        groupName.includes(normalizedQuery) ||
        assignedbyName.includes(normalizedQuery)
      );
    });
  }, [searchQuery, myTrainingData, handleAssignTo, handleAssignBy, handleGroupName]);

  // Derive pagination from searchedTraining (no extra state/effect = no update loop)
  const totalItems = searchedTraining.length;
  const startIdx = (currentPage - 1) * itemsPerPage;
  const endIdx = startIdx + itemsPerPage;
  const totalPages = Math.ceil(searchedTraining.length / itemsPerPage);

  // Get data for current page
  const currentData = searchedTraining.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handleReminderSent = async (training) => {
    const trainingId = training?._id
    setIsLoading(true);
    try {
      await dispatch(sendTrainingReminder(trainingId));
      enqueueSnackbar("Reminder Sent Successfully", { variant: "success" });
      dispatch(getMyTrainings());
    } catch (err) {
      console.error("Reminder error:", err);
    } finally {
      setIsLoading(false);
      dispatch(getMyTrainings());
    }
  }

  if (!loggedEmp || !canShowMyTraining) {
    return null;
  }

  return (

    <>
      <div className='bg-white rounded-md py-1'>
        {isLoading ? <AdminLoader isLoading={isLoading} /> : <> </>}
        <div className="flex justify-between items-center p-2 bg-white  ">
          <div className="font-semibold">
            My Trainings
          </div>

          <div className="flex gap-2 py-1 px-1 align-middle items-center bg-[#e0e7ff] rounded-full">
            <MdSearch className=" w-5 h-5 text-gray-500" />
            <input
              type="text"
              value={searchQuery}
              onChange={handleSearchInputChange}
              placeholder="Search"
              className="bg-[#e0e7ff] outline-none w-[80%]"
            />
          </div>
        </div>
        <div ref={tableScrollRef} className="w-full  max-h-[80vh] overflow-auto ">
          <div className="flex bg-[#E8E8E8] text-black h-12 font-semibold text-xs sticky top-0 z-[999] text-center ">
            <div className=" p-1 flex-shrink-0 w-12 flex justify-center items-center">Sr. No</div>
            <div className=" pl-6 flex-shrink-0 w-36 flex justify-start items-center">Group Name</div>
            <div className=" pl-6 flex-shrink-0 w-40 flex justify-start items-center">Project Name</div>
            <div className=" pl-5 flex-shrink-0 w-40 flex justify-start items-center">Training Name</div>
            <div className=" p-2 flex-shrink-0 w-32 flex justify-start items-center">Assigned By</div>
            <div className="pl-5 flex-shrink-0 w-32 flex justify-start items-center text-left">Assign To</div>
            <div className="pl-2 bg-[#E8E8E8] text-black flex-shrink-0 w-32 flex justify-center items-center">Due Date</div>
            <div className="pl-2 bg-[#E8E8E8] text-black flex-shrink-0 w-32 flex justify-center items-center">End Date</div>
            <div className=" bg-[#E8E8E8] text-black flex-shrink-0 w-40 flex justify-center items-center">Link To The Training</div>
            <div className=" p-2 bg-[#E8E8E8] text-black flex-shrink-0 w-40 flex justify-center items-center">Training Cost ({currency})</div>
            <div className="pl-3 bg-[#E8E8E8] text-black flex-shrink-0 w-40 flex justify-start items-center">Status</div>
            <div className=" p-2 bg-[#E8E8E8] text-black flex-shrink-0 w-24 flex justify-center items-center">Attachments</div>
            <div className=" p-2 bg-[#E8E8E8] text-black flex-shrink-0 w-20 flex justify-center items-center">
              <DeleteIcon
                className="deleteicon cursor-pointer text-black"
              />
            </div>
          </div>
          <div className=" table text-xs text-left mb-4 ">
            <div className=''>
              {currentData?.map((training, index) => {
                const actualIndex = startIdx + index;
                const isOwner = !training?._id || loggedEmp?._id === training?.assignedby;
                const canEditEndDate =
                  !isViewOnly &&
                  training?.status !== "Completed" &&
                  loggedEmp?._id === training?.assignedto;

                return (
                  <div key={index} className="flex text-black text-left">
                    <div className="pl-2 border-b border-gray-300 w-12 flex justify-start items-center"> {actualIndex + 1} </div>
                    <div className={` ${training?._id ? "flex justify-start items-center" : ""}  border-b border-gray-300 flex-shrink-0 w-36 break-words whitespace-normal `}>
                      {training?._id ?
                        <div className="pl-6">
                          {handleGroupName(training?.groupId)}
                        </div>
                        :
                        <div className="relative flex p-0 pt-2 pl-3 rounded-xl items-center">
                          <select
                            value={training?.groupId || ""}
                            disabled={isViewOnly || !!training?._id}
                            onChange={(e) => {
                              if (isViewOnly) return;
                              if (!training?._id) {
                                const selectedGroupId = e.target.value;
                                const selectedGroup = filteredEmpGroups.find((grp) => grp._id === selectedGroupId);
                                // eslint-disable-next-line no-console
                                console.log("TRAINING ROW", training);

                                setMyTrainingData(prev =>
                                  prev.map((item, i) =>
                                    i === actualIndex
                                      ? {
                                        ...item,
                                        groupId: selectedGroupId,
                                        group: selectedGroup,
                                        projectname: "",
                                        projectid: "",
                                        leadid: "",
                                        quotationId: "",
                                        assignedto: "",
                                        enddate: "",
                                        project: null
                                      }
                                      : item
                                  )
                                );
                                setSelectedProject("");
                              }
                            }}
                            className={`relative border w-28 text-xs border-gray-400 text-nowrap rounded-md p-2 pr-7 shadow-md overflow-hidden outline-none truncate
      ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : training?._id ? "bg-gray-100 cursor-default" : "bg-white cursor-pointer hover:bg-gray-50"}`}
                          >
                            <option hidden value="">Select Group</option>
                            {filteredEmpGroups.map(group => (
                              <option
                                key={group._id}
                                value={group._id}
                                className="whitespace-normal break-words"
                              >
                                {group?.newGroupName}
                              </option>
                            ))}
                          </select>
                        </div>
                      }
                    </div>
                    <div className={` ${training?._id ? "flex justify-start items-center" : ""} text-start py-2 border-b border-gray-300 flex-shrink-0 w-40 break-words whitespace-normal `}>
                      {training?._id ?
                        <div className="pl-6">
                          {getDisplayProjectName(training)}
                        </div>
                        :
                        <div className="relative flex p-0 pl-2 rounded-xl items-center">
                          <select
                            value={
                              isCrmPackage
                                ? (training?.quotationId || training?.leadid || "")
                                : (training?.quotationId || training?.projectid || training?.projectname || "")
                            }
                            disabled={isViewOnly}
                            onChange={(e) => {
                              if (isViewOnly) return;
                              if (!training?._id) {
                                const selectedProjectValue = String(e.target.value || "");
                                const selectedProject = filteredLeads
                                  .filter((l) => (l?.groupid || l?.AssignedGroup) === training?.groupId)
                                  .find((proj) => {
                                    const quotationMatch = String(proj?.quotationId || "") === selectedProjectValue;
                                    const idMatch = String(proj?._id || "") === selectedProjectValue;
                                    const nameMatch = String(proj?.ProjectName || "") === selectedProjectValue;
                                    return quotationMatch || idMatch || nameMatch;
                                  });
                                // eslint-disable-next-line no-console
                                console.log("PROJECT DATA", selectedProject);

                                if (selectedProject) {
                                  setMyTrainingData(prev =>
                                    prev.map((item, i) =>
                                      i === actualIndex
                                        ? {
                                          ...item,
                                          projectname: selectedProject.ProjectName,
                                          projectid: isErpPackage ? (selectedProject?._id || "") : "",
                                          leadid: isCrmPackage ? (selectedProject?._id || "") : "",
                                          quotationId: selectedProject?.quotationId || "",
                                          project: selectedProject,
                                          assignedto: "",
                                          enddate: "",
                                        }
                                        : item
                                    )
                                  );
                                  setSelectedProject(selectedProject);
                                }
                              }
                            }}
                            className={`relative border w-28 text-xs border-gray-400 text-nowrap rounded-md py-2 pl-3 pr-7 shadow-md overflow-hidden outline-none truncate
                         ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : training?._id ? "bg-white cursor-default" : "bg-white cursor-pointer hover:bg-gray-50"}`}
                          >
                            <option hidden value="">Select</option>
                            {filteredLeads
                              .filter((l) => (l?.groupid || l?.AssignedGroup) === training?.groupId)
                              .filter((proj) => !isProjectMarkedComplete(proj))
                              .map(proj => (
                                <option
                                  key={proj?.quotationId || proj?._id}
                                  value={isCrmPackage ? (proj?.quotationId || proj?._id) : (proj?.quotationId || proj?._id || proj?.ProjectName)}
                                  className="p-1 hover:bg-gray-200 cursor-pointer"
                                >
                                  {proj.ProjectName}
                                </option>
                              ))}
                          </select>
                        </div>
                      }
                    </div>
                    <div className={` ${training?._id ? "flex justify-start items-center" : ""} py-2 border-b border-gray-300 flex-shrink-0 w-40 break-words whitespace-normal `}>
                      {training?._id ?
                        <div className="pl-6">
                          {training?.trainingname || " "}
                        </div>
                        :
                        <div className=" flex pl-2">
                          <input
                            type="text"
                            disabled={isViewOnly || training?._id}
                            value={training?.trainingname}
                            placeholder="Training Name"
                            onChange={(e) => {
                              if (isViewOnly) return;
                              const value = e.target.value;
                              setMyTrainingData(prev =>
                                prev.map((item, i) =>
                                  i === actualIndex ? { ...item, trainingname: value } : item
                                )
                              );
                            }}
                            className={`w-28 text-start border text-xs border-gray-400 text-nowrap rounded-md pl-4 py-2 shadow-md overflow-hidden outline-none
                      ${isViewOnly
                                ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed"
                                : training?._id
                                ? "bg-gray-100"
                                : "bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-100 placeholder-gray-400"
                              }`}
                          />
                        </div>
                      }
                    </div>
                    <div className="flex justify-start items-center align-middle pt-1 pl-2 border-b border-gray-300 flex-shrink-0 w-32 text-left">
                      {handleAssignBy(training?.assignedby)}
                    </div>
                    <div
                      className={`flex justify-start py-2 border-b border-gray-300 flex-shrink-0 w-32 min-w-0 text-left ${
                        training?._id ? "items-start" : "items-center"
                      }`}
                    >
                      {training?._id ?
                        <div className={`w-full min-w-0 px-2 ${loggedEmp?._id === training?.assignedto ? "pt-2" : "pt-1"}`}>
                          <span
                            className="block w-full text-left leading-snug break-words whitespace-normal"
                            title={handleAssignTo(training?.assignedto) || undefined}
                          >
                            {handleAssignTo(training?.assignedto)}
                          </span>
                        </div>
                        :
                        <>
                          {((loggedEmp?._id === training?.assignedto && !assignTOBoolean[actualIndex]) ? (
                            <div className="mx-2 box-border w-full max-w-full min-w-0 border border-gray-400 text-xs rounded-lg px-2.5 py-2 pr-8 shadow-md text-left bg-white truncate">
                              Self
                            </div>
                          ) : (
                            <div className="relative box-border mx-2 flex min-w-0 w-full max-w-full items-center rounded-xl">
                              <select
                                disabled={isViewOnly || !!training?._id}
                                value={training?.assignedto || ""}
                                onChange={(e) => {
                                  if (isViewOnly) return;
                                  const selectedValue = e.target.value;
                                  // Self option
                                  if (selectedValue === "self") {
                                    setMyTrainingData((prev) => {
                                      const copy = [...prev];
                                      copy[actualIndex].assignedto = loggedEmp._id;
                                      copy[actualIndex].projectid = resolveErpProjectIdForAssignee(copy[actualIndex], loggedEmp._id);
                                      copy[actualIndex].enddate = copy[actualIndex].enddate || "";
                                      return copy;
                                    });
                                    setselectedAssigedTo(loggedEmp);
                                    setAssignTOBoolean((prev) => {
                                      const temp = [...prev];
                                      temp[actualIndex] = true;
                                      return temp;
                                    });
                                    return;
                                  }

                                  if (isCrmL3Sales) {
                                    return;
                                  }
                                  if (isLoggedOperationsUser) {
                                    // Ops users cannot assign trainings to others
                                    return;
                                  }

                                  // Find selected employee (roster may not be in filtereedEmployees for PM path)
                                  const selectedEmp = (employees || []).find(
                                    (emp) => String(emp._id) === String(selectedValue)
                                  ) || filtereedEmployees.find((emp) => String(emp._id) === String(selectedValue));

                                  if (!selectedEmp) {
                                    enqueueSnackbar("Could not resolve the selected assignee.", {
                                      variant: "error",
                                    });
                                    return;
                                  }

                                  const assignmentSources = getSourcesForTrainingAssignments(training);
                                  const isAdminOrDirector =
                                    loggedEmp?.EmpAuthLevel === "L0" || loggedEmp?.EmpAuthLevel === "L1";
                                  // DEBUG: verify selected employee identity
                                  // eslint-disable-next-line no-console
                                  console.log("ASSIGNED EMPLOYEE OBJECT", selectedEmp);

                                  const isManagerUser =
                                    String(loggedEmp?.EmpAuthLevel || "") === "L4" && !isLoggedOperationsUser;

                                  const salesNeedsManagerAcceptGate =
                                    String(loggedEmp?.EmpAuthLevel || "") === "L3" && !isManagerUser;
                                  const salesDropdownManagers = salesNeedsManagerAcceptGate
                                    ? getSalesForwardedManagersForTrainingRow(training)
                                    : [];
                                  const selectedIsSalesDropdownManager = salesDropdownManagers.some(
                                    (emp) => String(emp?._id || "") === String(selectedEmp?._id || "")
                                  );
                                  const selectedHasExplicitReject = assignmentSources.some(
                                    (proj) =>
                                      isManagerRejectedForSpTraining(proj) ||
                                      flattenAssignedpersonLike(proj).some(
                                        (person) =>
                                          personMatchesTrainingEmployee(person, selectedEmp) &&
                                          isManagerRejectedForSpTraining(person)
                                      )
                                  );

                                  // Align with roster shapes: Assignedperson vs assignedperson, name-only rows, acceptance flags.
                                  const hasOmAssigned = isManagerUser
                                    ? true
                                    : isAdminOrDirector
                                      ? true
                                      : salesNeedsManagerAcceptGate &&
                                          selectedIsSalesDropdownManager &&
                                          !selectedHasExplicitReject
                                        ? true
                                      : assignmentSources.length > 0
                                        ? assignmentSources.some((proj) =>
                                          flattenAssignedpersonLike(proj).some((person) => {
                                            if (!personMatchesTrainingEmployee(person, selectedEmp)) return false;
                                            if (
                                              salesNeedsManagerAcceptGate &&
                                              !isManagerAcceptedForSpTraining(person) &&
                                              !isManagerAcceptedForSpTraining(proj)
                                            ) {
                                              return false;
                                            }
                                            return true;
                                          })
                                        )
                                        : true;

                                  if (!hasOmAssigned) {
                                    const isSalesUser = String(loggedEmp?.EmpAuthLevel || "") === "L3";
                                    enqueueSnackbar(
                                      isSalesUser
                                        ? "Manager has not accepted the project"
                                        : `${training?.projectname} has not been assigned to ${selectedEmp?.EmpFirstName} ${selectedEmp?.EmpLastName}`,
                                      { variant: "error" }
                                    );
                                    return;
                                  }

                                  setMyTrainingData((prev) => {
                                    const copy = [...prev];
                                    copy[actualIndex].assignedto = selectedEmp?._id;
                                    copy[actualIndex].projectid = resolveErpProjectIdForAssignee(copy[actualIndex], selectedEmp?._id);
                                    copy[actualIndex].enddate = "";
                                    return copy;
                                  });
                                  setselectedAssigedTo(selectedEmp);
                                }}
                                className={`assignToDropdown box-border w-full max-w-full min-w-0 appearance-auto border border-gray-400 text-xs rounded-lg py-2 pl-2.5 pr-[32px] leading-snug shadow-md text-left outline-none whitespace-nowrap overflow-hidden text-ellipsis ${
                                  isViewOnly
                                    ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed"
                                    : training?._id
                                      ? "bg-gray-100 cursor-default"
                                      : "cursor-pointer bg-white group-hover:bg-gray-100 hover:bg-gray-50"
                                  }`}
                              >
                                {/* Default placeholder */}
                                <option value="" disabled>
                                  {handleAssignTo(training?.assignedto) || "Select Assignee"}
                                </option>

                                {/* Self option (not allowed for L0/L1) */}
                                {!(loggedEmp?.EmpAuthLevel === "L0" || loggedEmp?.EmpAuthLevel === "L1") && (
                                  <option value="self">Self</option>
                                )}

                                {/* Filtered employees */}
                                {(() => {
                                  if (isCrmL3Sales) return null;
                                  if (isLoggedOperationsUser) return null;

                                  const currentUserRole =
                                    String(loggedEmp?.EmpAuthLevel || "") === "L3"
                                      ? "SP"
                                      : isLoggedOperationsUser
                                        ? "OPERATIONS"
                                        : String(loggedEmp?.EmpAuthLevel || "") === "L4"
                                          ? "MANAGER"
                                          : "OTHER";

                                  // eslint-disable-next-line no-console
                                  console.log("CURRENT ROLE", currentUserRole);
                                  // eslint-disable-next-line no-console
                                  console.log("ROW DATA", training);

                                  let candidates =
                                    loggedEmp?.EmpAuthLevel === "L3"
                                      ? getSalesForwardedManagersForTrainingRow(training)
                                      : isLoggedOperationsUser
                                        ? getOpsAssigneesForTrainingRow(training)
                                        : String(loggedEmp?.EmpAuthLevel || "") === "L4"
                                          ? getManagerForwardedOperationsForTrainingRow(training)
                                          : isLoggedProjectManager
                                            ? getPmAssigneesForTrainingRow(training)
                                          : filtereedEmployees
                                              .filter((emp) => emp.EmpGroups?.includes(training?.groupId))
                                              .filter((emp) => {
                                                const emailSet = new Set();
                                                const nameSet = new Set();
                                                getSourcesForTrainingAssignments(training).forEach((src) =>
                                                  accumulatePeopleFromAssignedLike(src, emailSet, nameSet)
                                                );
                                                const empEmail = normalizeTrainingEmail(emp.EmpEmail);
                                                const empName = `${emp.EmpFirstName || ""} ${emp.EmpLastName || ""}`
                                                  .trim()
                                                  .toLowerCase();
                                                return (
                                                  (empEmail && emailSet.has(empEmail)) ||
                                                  (empName && nameSet.has(empName))
                                                );
                                              });

                                  if (isLoggedOperationsUser) {
                                    // Safety net: Ops users should never see Sales/PM roles here.
                                    candidates = (candidates || []).filter((emp) => {
                                      const roles = ([]).concat(emp?.customRoles || []).map((r) => String(r || "").toLowerCase());
                                      const isSales = roles.some((r) => r.includes("sales"));
                                      const isPm = roles.some((r) => r.includes("project") && r.includes("manager"));
                                      return !isSales && !isPm;
                                    });
                                  }

                                  // eslint-disable-next-line no-console
                                  console.log("FORWARDED USERS", candidates);

                                  return (candidates || []).map((emp) => (
                                    <option key={emp._id} value={emp._id} className="text-left">
                                      {emp.EmpFirstName + " " + emp.EmpLastName}
                                    </option>
                                  ));
                                })()}
                              </select>
                            </div>
                          ))}
                        </>
                      }

                    </div>
                    <div className={`flex justify-center items-center pl-2 border-b border-gray-300 flex-shrink-0 w-32 `}>
                      {training?.status === "Completed" ?
                        <div className='flex justify-center items-center align-middle'>
                          {training?.duedate
                            ? formatDateByCountry(training.duedate)
                            : ""}
                        </div>
                        :
                        <div className={`flex justify-center items-center align-middle`}>
                          <DatePicker
                            disabled={isViewOnly || training?.status === "Completed"}
                            selected={training.duedate ? new Date(training.duedate) : null}
                            onChange={(date) => {
                              if (isViewOnly) return;
                              setMyTrainingData(prev =>
                                prev.map((item, i) =>
                                  i === actualIndex
                                    ? { ...item, duedate: date }
                                    : item
                                )
                              );
                            }}
                            minDate={new Date()}
                            dateFormat={getDateFormat()}
                            placeholderText={getDatePlaceholder()}
                            popperPlacement="bottom-start"
                            popperClassName="z-[1199]"
                            className={`text-center w-full border text-xs border-gray-400 text-nowrap rounded-md p-2 shadow-md  overflow-hidden outline-none
                    ${isViewOnly
                                ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed"
                                : training?.status === "Completed"
                                ? "bg-gray-100 cursor-default"
                                : "bg-white cursor-pointer hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-100 placeholder-gray-400"
                              }`}
                          />
                        </div>
                      }
                    </div>
                    <div className={`flex justify-center items-center pl-2 border-b border-gray-300 flex-shrink-0 w-32 `}>
                      {training?.status === "Completed" ?
                        <div className='flex justify-center items-center align-middle'>
                          {training?.enddate
                            ? formatDateByCountry(training.enddate)
                            : ""}
                        </div>
                        :
                        <div className={`flex justify-center items-center align-middle`}>
                          <DatePicker
                            disabled={!canEditEndDate}
                            selected={training.enddate ? new Date(training.enddate) : null}
                            onChange={(date) => {
                              if (isViewOnly) return;
                              setMyTrainingData(prev =>
                                prev.map((item, i) =>
                                  i === actualIndex
                                    ? { ...item, enddate: date }
                                    : item
                                )
                              );
                            }}
                            minDate={new Date()}
                            dateFormat={getDateFormat()}
                            placeholderText={getDatePlaceholder()}
                            popperPlacement="bottom-start"
                            popperClassName="z-[1199]"
                            className={`text-center w-full border text-xs border-gray-400 text-nowrap rounded-md p-2 shadow-md  overflow-hidden outline-none
                    ${!canEditEndDate
                                ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed"
                                : training?.status === "Completed"
                                ? "bg-gray-100 cursor-default"
                                : "bg-white cursor-pointer hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-100 placeholder-gray-400"
                              }`}
                          />
                        </div>
                      }
                    </div>
                    <div className={` ${training?._id ? "flex justify-start items-center" : ""} py-2 border-b border-gray-300 flex-shrink-0 w-40 break-words whitespace-normal `}>
                      {""}
                      {training?.status === "Completed" ?
                        <div className="pl-6">
                          {training?.linktotraining || " "}
                        </div>
                        :
                        <div className="flex pl-6">
                          <input
                            type="text"
                            value={training?.linktotraining}
                            placeholder="Link To Training"
                            onChange={(e) => {
                              if (isViewOnly) return;
                              const value = e.target.value;
                              setMyTrainingData(prev =>
                                prev.map((item, i) =>
                                  i === actualIndex ? { ...item, linktotraining: value } : item
                                )
                              );
                            }}
                            className={`w-28 border text-xs border-gray-400 text-nowrap rounded-md p-2 shadow-md text-start overflow-hidden outline-none
                      ${isViewOnly
                                ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed"
                                : training?.status === "Completed"
                                ? "bg-gray-100 "
                                : "bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-100 placeholder-gray-400"
                              }`}
                            disabled={isViewOnly || training?.status === "Completed"}
                          />
                        </div>
                      }
                    </div>
                    <div className={`${loggedEmp?._id !== training?.assignedto ? "flex justify-center items-center" : "flex justify-center items-center"} p-2 border-b border-gray-300 flex-shrink-0 w-40 `}>
                      {
                        (training?.status === "Completed" && training?.trainingcost && !showsubmit[actualIndex])
                          ? (
                            <span>{USAComma(training?.trainingcost)}</span>
                          )
                          :
                          (
                            <input
                              type="text"
                              value={USAComma(training?.trainingcost)}
                              placeholder="Training Cost"
                              disabled={isViewOnly}
                              onChange={(e) => {
                                if (isViewOnly) return;
                                let value = e.target.value.replace(/,/g, "");
                                if (!/^\d*$/.test(value)) return;
                                setMyTrainingData(prev =>
                                  prev.map((item, i) =>
                                    i === actualIndex ? { ...item, trainingcost: value } : item
                                  )
                                );
                              }}
                              className={`w-28 border text-xs border-gray-400 text-nowrap rounded-md p-2 shadow-md overflow-hidden outline-none text-center ${isViewOnly
                                ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed"
                                : "bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-100 placeholder-gray-400"
                              }`}
                            />
                          )}

                    </div>
                    <div className=" p-2 border-b border-gray-300 flex-shrink-0 w-40 flex justify-start items-center align-middle">
                      {
                        (training?.status === "Completed" && !showsubmit[actualIndex])
                          ? (
                            <span className=''>{training?.status}</span>
                          ) : (
                            // ) : loggedEmp?._id === training?.assignedto ? (
                            <div className="relative flex justify-center p-0 rounded-xl items-center cursor-pointer">
                              <select
                                value={training?.isReminder ? "Reminded" : training?.status || ""}
                                disabled={isViewOnly}
                                onChange={(e) => {
                                  if (isViewOnly) return;
                                  const selectedStatus = e.target.value;
                                  if (!selectedStatus) return;
                                  if (selectedStatus === "Reminder") {
                                    handleReminderSent(training);
                                    setMyTrainingData(prev =>
                                      prev.map((item, i) =>
                                        i === actualIndex
                                          ? { ...item, isReminder: true }
                                          : item
                                      )
                                    );
                                    return;
                                  }
                                  if (selectedStatus) {
                                    setShowSubmit(prev => {
                                      const temp = [...prev];
                                      temp[actualIndex] = true;
                                      return temp;
                                    });
                                    setMyTrainingData(prev =>
                                      prev.map((item, i) =>
                                        i === actualIndex
                                          ? {
                                            ...item,
                                            status: selectedStatus,
                                          }
                                          : item
                                      )
                                    );
                                  }
                                }}
                                className={`w-28 border text-xs border-gray-400 text-nowrap rounded-md py-1.5 px-2 shadow-md overflow-hidden outline-none h-8 ${isViewOnly
                                  ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed"
                                  : "bg-white cursor-pointer hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-100"
                                }`}
                              >
                                <option hidden value="">{training?.isReminder ? "Reminded" : training?.status || "Select"}</option>
                                {/* {training?.isReminder && (
                                <option value="Reminded" disabled>
                                  Reminded
                                </option>
                              )} */}

                                <option
                                  disabled={!training?.trainingcost}
                                  value="Completed"
                                  className="p-1 hover:bg-gray-200 cursor-pointer"
                                >
                                  Completed
                                </option>
                                <option
                                  value="Not-Completed"
                                  className="p-1 hover:bg-gray-200 cursor-pointer"
                                >
                                  Not Completed
                                </option>

                                {(loggedEmp?._id !== training?.assignedto && training?._id) && (
                                  <>
                                    {!training?.isReminder && (
                                      <option value="Reminder"
                                        className="p-1 hover:bg-gray-200 cursor-pointer"
                                      >Reminder</option>
                                    )}
                                  </>
                                )}

                              </select>
                            </div>
                            // ) : (
                            //   <>
                            //     {training?.status}
                            //   </>
                          )}

                    </div>
                    <div className="p-2 border-b border-gray-300 flex-shrink-0 w-24 flex justify-center items-center align-middle">

                      <AttachFileIcon
                        onClick={() => {
                          setPopupProject(true);
                          if (training?._id) {
                            setSelectedFile([])
                          }
                          setTrainingRow(training)
                          getTrainingFileData(training?._id)
                          setOpenDropdownIndex(openDropdownIndex === null);
                        }}
                        className="rotate-12 cursor-pointer"
                      />


                    </div>
                    <div className="p-2 border-b border-gray-300 flex-shrink-0 w-20 flex justify-center items-center">

                      {/* <DeleteIcon
                      disabled={!loggedEmp?._id === training?.assignedby}
                      onClick={() => {
                        setIsModal(true)
                        setTrainingID(training?._id)
                        setTrainingIndex(actualIndex)
                      }}
                      className={`deleteicon ${loggedEmp?._id === training?.assignedby ? "cursor-pointer" : "text-gray-400 cursor-not-allowed"}`}
                    /> */}
                      <span title={isViewOnly ? "View Only" : isOwner ? "Delete" : "Only Assigned person can delete"}>
                        <DeleteIcon
                          onClick={() => {
                            if (isViewOnly) return;
                            if (!isOwner) return;
                            setIsModal(true);
                            setTrainingID(training?._id);
                            setTrainingIndex(startIdx + index);
                          }}
                          className={`deleteicon ${isViewOnly
                            ? "text-[#9ca3af] cursor-not-allowed pointer-events-none opacity-60"
                            : isOwner
                            ? "cursor-pointer"
                            : "text-gray-300 cursor-default"
                            }`}
                        />
                      </span>

                    </div>
                  </div>
                )
              })}
              {currentData.length === 0 && (
                <div className="noDataAvailable p-2">No Result Found</div>
              )}
            </div>

          </div>
        </div>

        <div>
          <div className="pl-3 w-full flex justify-between mt-4 pb-2">
            <div className='rounded-md shadow-lg'>
              {mytrainingOMMyManagement !== "Assignment" && (
                <AddIcon
                  onClick={handleNewTrainingRow}
                  className={isViewOnly
                    ? "text-[#9ca3af] cursor-not-allowed pointer-events-none opacity-60"
                    : "cursor-pointer text-black"
                  }
                />
              )}
            </div>
            <div className="flex justify-start ">
              {/* {mytrainingOMMyManagement !== "Assignment" && ( */}
              <button
                disabled={isViewOnly}
                onClick={() => {
                  if (isViewOnly) return;
                  handleTrainingSubmit();
                  setShowSubmit([])
                }}
                className={`text-[13px] mr-3 py-1 px-3 overflow-hidden shadow-md rounded-md ${isViewOnly
                  ? "bg-[#d1d5db] text-[#9ca3af] cursor-not-allowed pointer-events-none"
                  : "bg-[#e32278] hover:bg-[#e12298] text-white"
                }`}>
                {"Submit"}
              </button>
              {/* )} */}
            </div>

          </div>
        </div>
      </div >

      <div className="pt-2">
        {currentData.length > 0 && (
          <div className="pagination p-3 flex justify-between items-center bg-white rounded-md pb-2">
            <div>
              {totalItems > 0 ? (
                <>
                  Showing {startIdx + 1} to{" "}
                  {Math.min(endIdx, totalItems)} of {totalItems}{" "}
                  Entries
                </>
              ) : (
                <>Showing 0 Entries</>
              )}
            </div>
            {totalPages > 1 && (
              <div>
                <button
                  onClick={() => setCurrentPage(1)}
                  className="px-2 py-2 mx-1 border rounded"
                  disabled={currentPage === 1}
                  title="First Page"
                >
                  <KeyboardDoubleArrowLeftIcon className="w-5 h-5" />
                </button>
                <button
                  onClick={() =>
                    setCurrentPage((prev) =>
                      Math.max(prev - 1, 1)
                    )
                  }
                  className="px-2 py-2 mx-2 border rounded"
                  disabled={currentPage === 1}
                >
                  <ChevronRightIcon className="w-5 h-5 rotate-180" />

                  {/* Previous */}
                </button>

                {Array.from({ length: 3 }, (_, index) => {
                  // Calculate the page number for the current range
                  const pageNumber = currentPage - 1 + index;

                  // Ensure the pageNumber stays within bounds
                  if (
                    pageNumber >= 1 &&
                    pageNumber <= totalPages
                  ) {
                    return (
                      <button
                        key={pageNumber}
                        onClick={() => setCurrentPage(pageNumber)}
                        className={`px-2 py-2 mx-2 border rounded ${currentPage === pageNumber
                          ? "bg-gray-300"
                          : ""
                          }`}
                      >
                        {pageNumber}
                      </button>
                    );
                  }

                  // Return null for out-of-bounds values
                  return null;
                })}

                <button
                  onClick={() =>
                    setCurrentPage((prev) =>
                      Math.min(prev + 1, totalPages)
                    )
                  }
                  className="p-2 border rounded"
                  disabled={currentPage === totalPages}
                >
                  <ChevronRightIcon className="w-5 h-5" />
                  {/* Next */}
                </button>
                <button
                  onClick={() => setCurrentPage(totalPages)}
                  className="px-2 py-2 mx-1 border rounded"
                  disabled={currentPage === totalPages}
                  title="Last Page"
                >
                  <KeyboardDoubleArrowRightIcon className="w-5 h-5" />
                </button>
              </div>
            )}
          </div>
        )}
      </div>
      {
        isModal && (
          <div className="fixed inset-0 flex items-center justify-center z-[1400] bg-black bg-opacity-50">
            <div className="bg-white rounded-lg shadow-lg p-6 w-[90%] max-w-md">
              <h2 className="text-xl font-semibold mb-3 text-start">
                Confirm Deletion
              </h2>
              <p className="text-gray-700 mb-4 text-start">
                Are you sure you want to delete this Training ?
              </p>
              <div className="flex justify-start gap-3">

                <button
                  onClick={confirmDelete}
                  className="px-4 py-2 rounded-md bg-red-600 hover:bg-red-700 text-white font-semibold"
                >
                  Delete
                </button>

                <button
                  onClick={() => setIsModal(false)}
                  className="px-4 py-2 rounded-md border border-gray-300 bg-gray-100 hover:bg-gray-200 text-gray-700"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )
      }

      {popupProject && (
        <FileUploadMyTraining
          selectedProject={selectedProject}
          training={trainingRow}
          setSelectedFile={setSelectedFile}
          selectedFile={selectedFile}
          setPopupProject={setPopupProject}
          popupProject={popupProject}
          getTrainingFileData={getTrainingFileData}
          isViewOnly={isViewOnly}
        />
      )}
    </>
  )
}

export default MyTraining

